/* Amazon-style deals countdown timer as a custom element. */
class DealCountdown extends HTMLElement {
  connectedCallback() {
    const endAttr = this.getAttribute('data-end');
    this.clock = this.querySelector('.amazon-deals__timer-clock');
    if (!endAttr || !this.clock) return;

    // Support "YYYY-MM-DD HH:MM" by converting the space to "T" for Safari.
    const end = new Date(endAttr.replace(' ', 'T')).getTime();
    if (Number.isNaN(end)) return;

    this.tick = this.tick.bind(this);
    this.tick();
    this.interval = setInterval(this.tick, 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  tick() {
    const now = Date.now();
    let diff = Math.floor((this.endTime - now) / 1000);
    if (this.endTime === undefined) {
      this.endTime = new Date(this.getAttribute('data-end').replace(' ', 'T')).getTime();
      diff = Math.floor((this.endTime - now) / 1000);
    }

    if (diff <= 0) {
      this.clock.textContent = 'Deal ended';
      if (this.interval) clearInterval(this.interval);
      return;
    }

    const days = Math.floor(diff / 86400);
    const hours = Math.floor((diff % 86400) / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;
    const pad = (n) => String(n).padStart(2, '0');

    this.clock.textContent =
      (days > 0 ? days + 'd ' : '') + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }
}

if (!customElements.get('deal-countdown')) {
  customElements.define('deal-countdown', DealCountdown);
}
